import './App.css';

import { BrowserRouter, Route, Routes, useParams } from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { AdminPage } from './pages/Admin';
import { ListingPage } from './pages/ListingPage';
import { ListingsPage } from './pages/ListingsPage';
import { MainPage } from './pages/Main';
import MyFooter from './components/Footer';
import Navbar from './components/Navbar';

const theme = createTheme({
  palette: {
    primary: {
      main: '#9b8b4b', // 
      light: '#9b8b4b',
      dark: '#9b8b4b',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9b8b4b', // Pink
      light: '#9b8b4b',
      dark: '#9b8b4b',
      contrastText: '#fff',
    },
  },
});


function App() {
  const other = useParams<{ category: string, city: string }>();
  console.log("the category is", other);
  return (
    <ThemeProvider theme={theme}>
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          // colorPrimary: 'white',
          borderRadius: 2,
          // colorText: 'black',
          colorTextDescription: 'silver',
          // Alias Token
          // colorBgContainer: 'black',
        },
      }}
    >
      <Layout>
         <Navbar /> 


        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/properties" element={<ListingsPage />} />
            <Route path="/properties/*" element={<ListingPage />} />
            {/* <Route path="/:id" element={<ListingPage />} /> */}
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        {/* <Footer style={{ textAlign: 'center', backgroundColor: '#001529', width: "100%", color: 'white' }}> */}
          <MyFooter />
        {/* </Footer> */}
        </Layout>
      </ConfigProvider>
    </ThemeProvider>
  );
}

export default App;